export interface GetCountyListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCountyListPagingAndFilterResponseData
}

export interface GetCountyListPagingAndFilterResponseData {
    items: GetCountyListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCountyListPagingAndFilterResponseItem {
    countyId: string
    code: string
    name: string
    stateCode: string
    regionId: string
    regionName: string
    countryId: string
    countryName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCountyListPagingAndFilterResponseData: GetCountyListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}